(function () {
  'use strict';

  angular.module('sempraWebapp').factory('newsActions', newsActionsFactory);

  /** @ngInject */
  function newsActionsFactory(api, $q) {
    return {
      getCompanyNews: getCompanyNews,
      deleteNews : deleteNews,
      saveNews : saveNews,
      getGlobalNotice: getGlobalNotice
    };

    function getCompanyNews(page, pageSize, orderBy, order, companyId) {
      var deferred = $q.defer();
      api.getCompanyNews(page, pageSize, orderBy, order, companyId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteNews(newsId) {
      var deferred = $q.defer();
      api.deleteNews(newsId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function saveNews(data) {
      var deferred = $q.defer();
      api.saveNews(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getGlobalNotice() {
      var deferred = $q.defer();
      api.getGlobalNotice().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

  }
})();
